document.addEventListener('DOMContentLoaded', function() {
  const countrySelector = document.querySelector('#HeaderCountryForm select');
  const languageSelectorButton = document.querySelector('.disclosure__button');
  const languageSelectorList = document.querySelector('.disclosure__list-wrapper');
  const languageSelectorLinks = document.querySelectorAll('.disclosure__link');

  // Debugging: log the country and language selector elements
  console.log('Country Selector:', countrySelector); 
  console.log('Language Selector Button:', languageSelectorButton); 

  // Check if the country and language selectors are found
  if (countrySelector && languageSelectorButton && languageSelectorList) {
    // When the country is changed
    countrySelector.addEventListener('change', function() {
      const selectedCountry = countrySelector.value;

      // Debugging: log the selected country
      console.log('Selected Country:', selectedCountry);

      // Map of countries to their language codes
      const countryToLanguage = {
        'Germany': 'de',   // Germany -> German
        'Netherlands': 'nl', // Netherlands -> Dutch
        'United States': 'en', // United States -> English
        // Add other country-to-language mappings here
      };

      // If a language is mapped to the selected country
      if (countryToLanguage[selectedCountry]) {
        const selectedLanguageCode = countryToLanguage[selectedCountry];

        // Loop through language selector links to find the corresponding language
        languageSelectorLinks.forEach(link => {
          if (link.dataset.value === selectedLanguageCode) {
            // Update the language button text and the hidden input
            languageSelectorButton.querySelector('span').textContent = link.querySelector('span').textContent;
            document.querySelector('input[name="locale_code"]').value = selectedLanguageCode;

            // Simulate the click to change the language
            link.click();
          }
        });
      }
    });
  }
});
